import axios from "axios";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Loader from "./Loader";
import Message from "./Message";
import { logout } from "../actions/userActions";
import { notify } from "./notify";
import { useDispatch, useSelector } from "react-redux";
import { FaTrashAlt } from "react-icons/fa";

const VisitDeleteButton = ({ visit, setVisitsVehicle }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const dispatch = useDispatch();
  const deleteVisit = async () => {
    if (!window.confirm("Are you sure?")) {
      return;
    }

    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.delete(
        `/api/visits/${visit._id}`,

        config,
      );

      if (data.toString() === visit._id.toString()) {
        setLoading(false);
        setVisitsVehicle();
        notify({
          title: "Physician Section Action",
          message: <p className="lead">Data added successfully.</p>,
          type: "success",
          duration: 4000,
        });
      }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setLoading(false);
      setError(message);
    }
  };
  return (
    <div>
      {loading ? (
        <Loader />
      ) : error ? (
        <Message
          children={`Delete Err: ${error}`}
          setMessage={setError}
          variant={`danger`}
        />
      ) : (
        <Button
          className="w-100 p-2 my-2"
          variant="danger"
          onClick={() => deleteVisit()}
        >
          <FaTrashAlt /> DELETE VISIT
        </Button>
      )}
    </div>
  );
};

export default VisitDeleteButton;
